/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_P1tInputs */

const en_mk_sol_ukm_p1t = /** @type {(inputs: Mk_Sol_Ukm_P1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The daily recap is retyped every morning`)
};

const id_mk_sol_ukm_p1t = /** @type {(inputs: Mk_Sol_Ukm_P1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekap harian dikerjakan manual tiap pagi`)
};

/**
* | output |
* | --- |
* | "The daily recap is retyped every morning" |
*
* @param {Mk_Sol_Ukm_P1tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_p1t = /** @type {((inputs?: Mk_Sol_Ukm_P1tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_P1tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_p1t(inputs)
	return en_mk_sol_ukm_p1t(inputs)
});